import fluxHelper from './helper';
import fluxStepper from './stepper';
import fluxLoginButtons from './loginButtons';

var fluxValidation = {};

/**
 * Run.
 */
fluxValidation.init = function() {
    this.onChange();
    jQuery( document.body ).on( 'checkout_error', fluxValidation.onCheckoutError );
};

/**
 * Validation on Change.
 * 
 * By default Woo does not provide inline validation messages. 
 * We use AJAX to get the correct message and then trigger Woo validation.
 */
fluxValidation.onChange = function() {
    var fields = document.querySelectorAll( 'input, select, textarea' );
    Array.from( fields ).forEach( function( field ) {
        field.addEventListener( 'change', async function( e ) {
            e.preventDefault();
            e.stopPropagation();

            await fluxValidation.checkFieldForErrors( field );

            return false;
        } );
    });
};

/**
 * Check Field for Errors.
 *
 * @param {array} fields Fields.
 * @returns bool
 */
fluxValidation.checkFieldForErrors = async function( field ) {

    var row = field.closest('.form-row');

    if ( ! row ) {
        return false;
    }
    
    if ( ! row.attributes['data-label'] || ! row.attributes['data-type'] ) {
        return false;
    }

    var value = fluxHelper.getFieldValue( field );
    var type = row.attributes['data-type'].value;
    var data = {
        action: 'check_for_inline_error',
        args: {
            label: row.attributes['data-label'].value,
            required: row.classList.contains( 'required' ),
            type: type,
        },
        country: document.getElementById('billing_country').value,
        key: field.attributes.name.value,
        value: value,
    };

    // Its too slow to trigger every field, so check the more advanced fields with ajax.
    if ( 'country' === type || 'postcode' === type || 'phone' === type || 'email' === type ) {
        await fluxHelper.ajaxRequest( data, function( response ) {
            var value = JSON.parse( response ).data;
    
            // Update the inline validation messages for the field.
            field.closest( '.form-row' ).querySelector( '.error' ).innerHTML = value.message;
            field.closest( '.form-row' ).classList.remove( 'woocommerce-invalid' );
    
            // Trigger Woo Validation.
            if ( field.closest( '.form-row' ).classList.contains( 'validate-required' ) ) {
                jQuery( field ).trigger( 'validate' );
            }
    
            // If a custom message has been returned, mark the row as invalid.
            if ( value.isCustom ) {
                field.closest( '.form-row' ).classList.add( 'woocommerce-invalid' );
            }

            if ( 'email' === type && value.globalMessage ) {
                fluxValidation.displayGlobalNotice( value.globalMessage, 'info', 'message', value.globalData );
                fluxLoginButtons.onClick();
            }

            if ( 'email' === type && ! value.globalMessage ) {
                fluxValidation.clearErrorMessages( 'data-flux-error' );
            }
        } );
    } else {
        // Trigger Woo Validation.
        if ( field.closest( '.form-row' ).classList.contains( 'validate-required' ) ) {
            jQuery( field ).trigger( 'validate' );
        }
    }

    var hasError = field.closest( '.form-row' ).classList.contains( 'woocommerce-invalid' );

    if ( hasError ) {
        fluxStepper.disableNextSteppers( field.closest( '[data-step]' ).attributes[ 'data-step' ].value );
        // fluxValidation.scrollToError();
    }

    fluxValidation.accessibleErrors();

    return hasError;
};

/**
 * Check Fields for Errors.
 *
 * @param {array} fields Fields.
 * @returns bool
 */
fluxValidation.checkFieldsForErrors = async function( fields ) {
    var inputs = {};
    var hasErrors = false;

    // Return true is google address auto-complete field is present and empty.
    for ( var field of fields ) {
        if ( 'billing_address_search' === field.id ) {
            if ( '' === field.value.trim() && 'none' === jQuery('.woocommerce-billing-fields').css( 'display' ) ) {
                field.closest( '.form-row' ).classList.add( 'woocommerce-invalid' );
                jQuery( field ).trigger( 'validate' );
                field.closest( '.form-row' ).classList.add( 'woocommerce-invalid' );
    
                fluxStepper.removeSpinner();
                return true;
            }
        }
    }

    fluxStepper.loadSpinner();
    // Get all the data so we can do an inline validation.
    Array.from( fields ).forEach( function ( field ) {

        var row = field.closest('.form-row');

        if ( ! row ) {
            return;
        }
        
        if ( ! row.attributes['data-label'] || ! row.attributes['data-type'] ) {
            return;
        }

        var value = fluxHelper.getFieldValue( field );
        inputs[ field.attributes.name.value ] = {
            args: {
                label: row.attributes['data-label'].value,
                required: row.classList.contains( 'required' ),
                type: row.attributes['data-type'].value,
            },
            country: document.getElementById('billing_country').value,
            key: field.attributes.name.value,
            value: value,
        };
    });

    var data = {
        action: 'check_for_inline_errors',
        fields: inputs,
    };

    await fluxHelper.ajaxRequest( data, function( response ) {
        var messages = JSON.parse( response ).data;

        // Update the inline validation messages for each field.
        Object.entries( messages ).forEach( function( object ) {
            var key = object[0];
            var value = object[1];

            var field = document.querySelector( '[name="' + key + '"]' );

			if ( ! field ) {
				return;
			}

            field.closest( '.form-row' ).querySelector( '.error' ).innerHTML = value.message;
            field.closest( '.form-row' ).classList.remove( 'woocommerce-invalid' );

            // Trigger Woo Validation.
            if ( field.closest( '.form-row' ).classList.contains( 'validate-required' ) ) {
                jQuery( field ).trigger( 'validate' );
            }

            // If a custom message has been returned, mark the row as invalid.
            if ( value.isCustom ) {
                field.closest( '.form-row' ).classList.add( 'woocommerce-invalid' );
            }

            if ( field.closest( '.form-row' ).classList.contains( 'woocommerce-invalid' ) ) {
				hasErrors = true;
            }
        });
    } );
    fluxValidation.clearErrorMessages( 'data-flux-error' );

    // Check password strength if set.
    var passwords = fields[0].closest( '[data-step]' ).querySelectorAll( '#account_password' );

    Array.from( passwords ).forEach( function( password ) {
        if ( password.closest( '.woocommerce-account-fields' ).querySelector( '#createaccount' ) && ! password.closest( '.woocommerce-account-fields' ).querySelector( '#createaccount' ).checked ) {
            return;
        }

        if ( ! password.value ) {
            return;
        }

        if ( ! password.closest( '.form-row' ).querySelectorAll( '.woocommerce-password-strength.good, .woocommerce-password-strength.strong' ).length ) {
            hasErrors = true;
        }
    } );

    if ( hasErrors ) {
        var step = fields[0].closest( '[data-step]' ).attributes[ 'data-step' ].value;
        // document.querySelector( `[data-stepper-li="${step}"]`).classList.add( 'error' );
        document.querySelector( '[data-stepper-li="' + step + '"]' ).classList.add( 'error' ); // ES5 Support.
        fluxStepper.disableNextSteppers( step );
        fluxValidation.scrollToError();
        fluxValidation.validateSearchForm();
    }

    fluxValidation.accessibleErrors();
    fluxStepper.removeSpinner();

    return hasErrors;
};

/**
 * Scroll to first error on page.
 */
fluxValidation.scrollToError = function() {
    var error = document.querySelectorAll( '.woocommerce-invalid' )[0];
    if ( ! error ) {
        return;
    }
    error.scrollIntoView( { behavior: 'smooth' } );
};

/**
 * Accessible Errors.
 * 
 * Add some accessibility classes to our errors to help those using accessibility tools.
 */
fluxValidation.accessibleErrors = function() {
    var fields = document.querySelectorAll( 'input, select, textarea' );
    Array.from( fields ).forEach( function( field ) {
        var row = field.closest( '.form-row' );

        if ( ! row ) {
            return;
        }

        var error = row.querySelector( '.error' );
        
        if ( error ) {
            error.setAttribute( 'aria-hidden', 'true' );
            error.setAttribute( 'aria-live', 'off' );
        }

        if ( row.classList.contains( 'woocommerce-invalid' ) ) {
            field.setAttribute( 'aria-invalid', 'true' );
            
            if ( error ) {
                error.setAttribute( 'aria-hidden', 'false' );
                error.setAttribute( 'aria-live', 'polite' );
            }
        }
    });
};

/**
 * Display Global Notice.
 * 
 * Render a global validation notice. Useful when an inline message is not possible.
 * 
 * @param {string} message Message.
 * @param {string} type Type.
 * @param {string} format Format.
 */
fluxValidation.displayGlobalNotice = function( message, type, format, data ) {

    // ES5 Support.
    if ( ! type ) {
        type = 'error';
    }

    if ( ! format ) {
        format = 'list';
    }


    var noticeArea = document.querySelectorAll( '.woocommerce-notices-wrapper' );

    if ( ! noticeArea ) {
        return;
    }

    noticeArea = noticeArea[ noticeArea.length - 1 ];

    fluxValidation.clearErrorMessages( 'data-flux-error' );

    var noticeContainer = document.createElement( 'div' );
    var noticeType = 'woocommerce-error';

    if ( 'error' !== type ) {
        noticeType = 'woocommerce-message';
    }

    if ( 'info' === type ) {
        noticeType = 'woocommerce-info';
    }

    if ( typeof data === 'object' && !Array.isArray(data) && data !== null ) {
        Object.entries( data ).forEach( function ( object ) { 
            var key = object[0];
            var value = object[1];
            
            noticeContainer.setAttribute( key, value );
        } );
    }

    if ( 'list' === format ) {
        noticeContainer.classList.add( 'woocommerce-NoticeGroup' );
        noticeContainer.classList.add( 'woocommerce-NoticeGroup-checkout' );
        
        var noticeContainerList = document.createElement( 'ul' );
        noticeContainerList.setAttribute( 'role', 'alert' );
        noticeContainerList.classList.add( noticeType );

        var noticeListItem = document.createElement( 'li' );
        noticeListItem.innerHTML = message;

        noticeContainerList.append( noticeListItem );
        noticeContainer.append( noticeContainerList );
    } else {
        noticeContainer.setAttribute( 'role', 'alert' );
        noticeContainer.classList.add( noticeType );
        noticeContainer.innerHTML = message;
    }

    noticeArea.append( noticeContainer );
};

/**
 * Clear error messages.
 * 
 * @param {string} Group Clear error messages only for this group. Group is the name of the data-* attribute. Example data-flux-error.
 */
fluxValidation.clearErrorMessages = function( group ) {

    jQuery( '.woocommerce-notices-wrapper > div, .woocommerce-notices-wrapper ul' ).each( function () {
        // if group is provided, only remove the notices beloging to this group.
        if ( group ) {
            if ( jQuery( this ).attr( group ) ) {
                jQuery( this ).remove();
            }
        } else {
            jQuery( this ).remove();
        }
    } );

    jQuery( '.woocommerce-NoticeGroup' ).remove();
};

/**
 * Validate Search Form.
 * 
 * If there is a search form error, display a message.
 */
fluxValidation.validateSearchForm = function() {
    var addressSearches = document.querySelectorAll( '#billing_address_search' );
    Array.from( addressSearches ).forEach( function( addressSearch ) {
        var addressSection = addressSearch.closest( '.woocommerce-billing-fields__wrapper' ).querySelector( '.woocommerce-billing-fields' );
        var style = window.getComputedStyle( addressSection );
        if ( style.display === 'none' ) {
            // fluxValidation.displayGlobalNotice( flux_checkout_vars.i18n.errorAddressSearch ); // Do global notice.
            
            // Remove previous notices.
            Array.from( addressSearch.closest( '.form-row' ).querySelectorAll( '.error' ) ).forEach( function( error ) {
                error.remove();
            } );
            
            // Do inline notice.
            var row = addressSearch.closest( '.form-row' );
            row.classList.add( 'woocommerce-invalid' );

            var error = document.createElement( 'span' );
            error.setAttribute( 'aria-hidden', 'false' );
            error.setAttribute( 'aria-live', 'polite' );
            error.classList.add( 'error' );
            error.innerHTML = flux_checkout_vars.i18n.errorAddressSearch;
            row.append( error );
        }
    } );
};

/**
 * Display global errors on 'checkout_error' event.
 * 
 * @param {object} e Event.
 * @param {string} data Error message in HTML format.
 */
fluxValidation.onCheckoutError = function ( e, data ) {
    /**
     * In modern checkout layout, we use CSS to hide the default error messages because that breaks the layout.
     * So we need to display our own.
     */
    if ( fluxHelper.isModernCheckout() ) {
        fluxValidation.displayGlobalNotice( jQuery( data ).html(), 'error' );
    }
};

export default fluxValidation;